const A = 'active'
const S_SLIDER_ONE_IMAGE = '.js-slider-one-image'
const S_SLIDER_CONTAINER_ONE_IMAGE = '.js-slider-container-one-image'
const S_NAV_ITEM = '.js-slider-one-nav-item'

const mouseenterTypesNav = function () {
  this.classList.add(A)
  let slider = this.sliderElementOneImage && this.sliderElementOneImage.sliderOneImage
  if(slider){
    let id = this.getAttribute('data-nav');
    if (id !== undefined) {
      slider.goTo(id);
    }
  }
}
const mouseleaveTypesNav = function () {
  let slider = this.sliderElementOneImage
  if(slider){
    let navs = slider.querySelectorAll(S_NAV_ITEM)
    for (let j = 0; j < navs.length; j++) {
      let nav = navs[j]
      nav.classList.remove(A)
    }
  }
}

export default function () {
  let sliders = document.querySelectorAll(S_SLIDER_ONE_IMAGE)
  for (let i = 0; i < sliders.length; i++) {
    let slider = sliders[i]
    if(slider.sliderOneImage){
      slider.sliderOneImage.destroy()
    }
    slider.sliderOneImage = window.tns({
      "autoWidth": false,
      "items": 1,
      "gutter": 0,
      "touch": false,
      "mouseDrag": false,
      "center": true,
      "swipeAngle": false,
      "controls": false,
      "nav": false,
      "navAsThumbnails": false,
      "container": slider.querySelector(S_SLIDER_CONTAINER_ONE_IMAGE),
      "speed": 400
    });
    let navs = slider.querySelectorAll(S_NAV_ITEM)
    for (let j = 0; j < navs.length; j++) {
      let nav = navs[j]
      nav.sliderElementOneImage = slider;
      on(nav, 'mouseenter', mouseenterTypesNav)
      on(nav, 'mouseleave', mouseleaveTypesNav)
    }
  }
}
